<template>
  <div class="tcm-con flex flex-col">
    <!--  标题区域 start  -->
    <div class="tcm-title-con flex flex-col">
      <span class="title">{{ row.name }}</span>
      <div class="sub-title-con flex flex-row align-center">
        <img
          src="@/assets/tcm/Frame(5).png"
          alt=""
          class="icon mr-5"
        >
        <span class="sub-title text-ellipsis">{{ row.prescriptionSource }}</span>
      </div>
    </div>
    <!--  标题区域 end  -->
    <!--  操作区 start  -->
    <div class="option-con flex flex-row w-full mb-10">
      <!--      <el-popover class="w-full detail-btn" width="1000" placement="bottom-right">-->
      <!--        <template #reference>-->
      <!--          <el-button class="w-full" type="primary" plain>详情</el-button>-->
      <!--        </template>-->
      <!--        <template #default>-->
      <!--          <TcmDetail :row="row" />-->
      <!--        </template>-->
      <!--      </el-popover>-->
      <!--      <el-dialog title="详情" :visible.sync="detailVisiable">-->
      <!--        <TcmDetail :row="row" />-->
      <!--      </el-dialog>-->
      <el-button
        class="w-full"
        type="primary"
        plain
        @click="showDetail(row)"
      >详情
      </el-button>
      <el-button class="btn w-full" type="primary" @click="handleChoose">选择</el-button>
    </div>
    <!--  操作区 end  -->
    <!--  详情区域 start  -->
    <div class="body-con self-center">
      <div class="list-con">
        <!--     列表项 start    -->
        <div class="list-item flex flex-col w-full">
          <div class="label-con flex flex-row align-center">
            <img
              src="@/assets/tcm/Frame(23).png"
              alt=""
              class="icon"
            >
            <span class="label">主诉</span>
          </div>
          <div class="content">
            {{ row.symContent }}
          </div>
        </div>
        <!--     列表项 end    -->
        <!--     列表项 start    -->
        <div class="list-item flex flex-col w-full">
          <div class="label-con flex flex-row align-center">
            <img
              src="@/assets/tcm/Frame(23).png"
              alt=""
              class="icon"
            >
            <span class="label">四诊</span>
          </div>
          <div class="content">
            {{ row.fdmContent }}
          </div>
        </div>
        <!--     列表项 start    -->
        <div class="list-item flex flex-col w-full">
          <div class="label-con flex flex-row align-center">
            <img
              src="@/assets/tcm/Frame(23).png"
              alt=""
              class="icon"
            >
            <span class="label">中医病</span>
          </div>
          <div class="content">
            {{ row.chDiagContent }}
          </div>
        </div>
        <!--     列表项 end    -->
        <!--     列表项 start    -->
        <div class="list-item flex flex-col w-full">
          <div class="label-con flex flex-row align-center">
            <img
              src="@/assets/tcm/Frame(23).png"
              alt=""
              class="icon"
            >
            <span class="label">中医症</span>
          </div>
          <div class="content">
            {{ row.chYndromeContent }}
          </div>
        </div>
        <!--     列表项 end    -->
        <!--     列表项 start    -->
        <div class="list-item flex flex-col w-full">
          <div class="label-con flex flex-row align-center">
            <img
              src="@/assets/tcm/Frame(23).png"
              alt=""
              class="icon"
            >
            <span class="label">治法</span>
          </div>
          <div class="content">
            {{ row.chTherapyContent }}
          </div>
        </div>
        <!--     列表项 end    -->
        <!--     列表项 start    -->
        <div class="list-item flex flex-col w-full">
          <div class="label-con flex flex-row align-center">
            <img
              src="@/assets/tcm/Frame(6).png"
              alt=""
              class="icon"
            >
            <span class="label">方剂内容</span>
          </div>
          <div class="content">
            {{ row.prescriptionContent }}
          </div>
        </div>
        <!--     列表项 end    -->
        <!--     列表项 start    -->
        <div class="list-item flex flex-col w-full">
          <div class="label-con flex flex-row align-center">
            <img
              src="@/assets/tcm/Frame(22).png"
              alt=""
              class="icon"
            >
            <span class="label">方剂说明</span>
          </div>
          <div class="content">
            {{ row.prescriptionDescribe }}
          </div>
        </div>
        <!--     列表项 end    -->

      </div>
    </div>
    <!--  详情区域 end  -->
    <!--  统计区 start  -->
    <!--    <div class="count-con flex flex-row align-center w-full">-->
    <!--      <div class="count-item flex flex-col align-center">-->
    <!--        <span class="num">{{ row.dayNum }}</span>-->
    <!--        <span class="label">用药天数</span>-->
    <!--      </div>-->
    <!--      <div class="divider-line" />-->
    <!--      <div class="count-item flex flex-col align-center">-->
    <!--        <span class="num">{{ row.dayDoseNum }}</span>-->
    <!--        <span class="label">每日剂数</span>-->
    <!--      </div>-->
    <!--      <div class="divider-line" />-->
    <!--      <div class="count-item flex flex-col align-center">-->
    <!--        <span class="num">{{ row.dayFreq }}</span>-->
    <!--        <span class="label">每日次数</span>-->
    <!--      </div>-->
    <!--      <div class="divider-line" />-->
    <!--      <div class="count-item flex flex-col align-center">-->
    <!--        <span class="num">{{ row.doseNum }}</span>-->
    <!--        <span class="label">剂数</span>-->
    <!--      </div>-->
    <!--    </div>-->
    <!--  统计区 end  -->
    <!--  标识区 end  -->
    <div class="sign-con">
      <img v-if="row.prescriptionTypeSign==='1'" class="sign" src="@/assets/tcm/Frame(4).png" alt="sign">
      <img v-if="row.prescriptionTypeSign==='2'" class="sign" src="@/assets/tcm/Frame(9).png" alt="sign">
      <img v-if="row.prescriptionTypeSign==='3'" class="sign" src="@/assets/tcm/Frame(14).png" alt="sign">
      <img v-if="row.prescriptionTypeSign==='4'" class="sign" src="@/assets/tcm/Frame(19).png" alt="sign">
      <img v-if="row.prescriptionTypeSign==='5'" class="sign" src="@/assets/tcm/Frame(24).png" alt="sign">
    </div>
  </div>
</template>
<script>
// import TcmDetail from "@/components/TCMRx/comp/TcmDetail.vue"

export default {
  name: "Tcm",
  components: {
    // TcmDetail
  },
  props: {
    row: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      sign: "1",
      detailVisiable: false

    }
  },
  methods: {
    /**
     * 选择
     */
    handleChoose() {
      this.$emit("choose", this.row)
    },
    /**
     * 显示详情
     * @param row
     */
    showDetail(row) {
      this.$emit("detail", row)
    }
  }
}
</script>

<style scoped lang="scss">
.tcm-con {
  position: relative;
  width: 340px;
  background: linear-gradient(180deg, #E8F3FF 0%, #F9FDFD 100%);
  border-radius: 6px 6px 6px 6px;
  padding: 16px;

  // 标题
  .tcm-title-con {
    margin-bottom: 32px;

    .title {
      margin-bottom: 8px;
      font-family: PingFang SC, PingFang SC, serif;
      font-weight: bold;
      font-size: 20px;
      color: #1D2129;
      line-height: 28px;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }

    .sub-title-con {
      .icon {
        width: 22px;
        height: 22px;
      }

      .sub-title {
        max-width: 160px;
        font-family: Roboto, Roboto, serif;
        font-weight: normal;
        font-size: 14px;
        color: #4E5969;
        line-height: 22px;
        text-align: left;
        font-style: normal;
        text-transform: none;
      }
    }
  }

  // 详情区域
  .body-con {
    width: 308px;
    height: 800px;
    background: linear-gradient(360deg, #FFFFFF 0%, rgba(255, 255, 255, 0.8) 100%);
    border-radius: 6px 6px 6px 6px;
    padding: 0 12px 8px 12px;

    .list-item {
      .label-con {
        padding: 10px 0;

        .icon {
          width: 16px;
          height: 16px;
          margin-right: 4px;
        }

        .label {
          font-family: PingFang SC, PingFang SC, serif;
          font-weight: normal;
          font-size: 14px;
          color: #1D2129;
          line-height: 22px;
          text-align: left;
          font-style: normal;
          text-transform: none;
        }
      }

      .content {
        background: #F7F8FA;
        border-radius: 3px 3px 3px 3px;
        padding: 5px 8px;

        font-family: PingFang SC, PingFang SC, serif;
        font-weight: bold;
        font-size: 14px;
        color: #1D2129;
        line-height: 22px;
        text-align: left;
        font-style: normal;
        text-transform: none;
      }
    }
  }

  // 统计区
  .count-con {
    margin-bottom: 12px;

    .count-item {
      .num {
        font-family: Douyin Sans, Douyin Sans, serif;
        font-weight: bold;
        font-size: 14px;
        color: #1D2129;
        line-height: 22px;
        text-align: center;
        font-style: normal;
        text-transform: none;
      }

      .label {
        font-family: PingFang SC, PingFang SC, serif;
        font-weight: 400;
        font-size: 12px;
        color: #4E5969;
        line-height: 20px;
        text-align: center;
        font-style: normal;
        text-transform: none;
      }
    }

    .divider-line {
      width: 0;
      height: 20px;
      border-radius: 0 0 0 0;
      border: 1px solid #E5E6EB;
      margin: 0 20px;
    }
  }

  // 操作区
  .option-con {
    .detail-btn {
      margin-right: 12px;
    }
  }

  // 标识区
  .sign-con {
    position: absolute;
    right: 10px;
    top: 10px;

    .sign {
      width: 100px;
      height: 100px;
    }
  }
}
</style>
